import React from 'react'
import {
  VerificationFormFieldsContext,
  VerificationFormFieldsContextType
} from 'front-end/src/pages/auth/verification-user-form-step/VerificationFormFieldsContext'
import { useLoginContext } from 'front-end/src/pages/auth/login/LoginContext'
import { getSortedUserFields } from 'front-end/src/pages/auth/AuthHelpers'
import { observer } from 'mobx-react'
import { AllowedUserFieldsEnum } from 'shared/accountNameConfig'

export const WithVerificationFormFieldsContext: React.FC<{}> = observer(
  ({ children }) => {
    const { organisation } = useLoginContext()
    const context = React.useMemo((): VerificationFormFieldsContextType => {
      return {
        fields: getSortedUserFields(
          organisation?.accountNameLoginConfig?.fields_config
            ?.verificationFields as AllowedUserFieldsEnum[]
        )
      }
    }, [organisation])

    return (
      <VerificationFormFieldsContext.Provider value={context}>
        {children}
      </VerificationFormFieldsContext.Provider>
    )
  }
)

WithVerificationFormFieldsContext.displayName =
  'WithVerificationFormFieldsContext'
